import { transportations } from "@/api/transportation/useTransportationQuery";
import { LeftSpace } from "@/features/location/detail/LocationDetailForm";
import { ActionButtonBox } from "@/features/standard/ActionButtonBox";
import { ActionHeader } from "@/features/standard/ActionHeader";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Main } from "@/features/standard/Main";
import { Button, Tabs } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { TransportationDetailActionBar } from "../header/TransportationDetailActionBar";
import { TransportationDetailHeader } from "../header/TransportationDetailHeader";
import { TransportationWmsLogTab } from "../tab/TransportationWmsLogTab";

const Detail = Object.assign({}, Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
  ActionBar: TransportationDetailActionBar,
  ActionHeader: ActionHeader,
  ActionButtonBox: ActionButtonBox,
  ActionBox: Button,
});

interface TransportationDetailFormProps {
  transportationID: number | undefined;
}

export const TransportationDetailForm = (params: TransportationDetailFormProps) => {
  const { transportationID } = params;
  const { t } = useTranslation();
  const { data: transportationData } = useQuery(
    transportations.detail({
      transportationId: transportationID ?? 0,
      populate: ["vehicle", "stockPlans", "wmsLogs"],
    }),
  );

  return (
    <Detail.Container>
      <Detail.ActionBar formatterProps={transportationData?.data} />
      <Detail.Wrapper>
        <Detail.Content>
          {/* <TransportationDetailDataHeader /> */}
          <TransportationDetailHeader data={transportationData?.data} />
          <Tabs defaultValue="wmsLogs">
            <LeftSpace />
            <Tabs.List>
              <Tabs.Tab value="wmsLogs">{t("transportation.record")}</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="wmsLogs">
              <TransportationWmsLogTab wmsLogs={transportationData?.data?.wmsLogs ?? []} />
            </Tabs.Panel>
          </Tabs>
        </Detail.Content>
      </Detail.Wrapper>
    </Detail.Container>
  );
};
